namespace Portico.Models {
    export class PorticoException {
        constructor(
            public errorMessage: string,
            public rawError: string,
            public errorCode?: number,
            public dataDump?: string
        ) { }
    }
}